import styled, { createGlobalStyle, css } from 'styled-components'
import { Calendar } from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'

const DnDCalendar = withDragAndDrop(Calendar)

export const StyledCalendarContainer = styled.div`
  position: relative;
  &:not(.no-scroll) {
    height: 600px;
  }
  > .ant-spin {
    position: absolute;
    left: 50%;
    top: 50vh;
    transform: transform3d(-50%, -50%, 0);
    z-index: 10;
  }

  .rbc-time-view-resources .rbc-day-slot,
  .rbc-row:not(.rbc-month-header) .rbc-header {
    min-width: ${props => `${props.minRoomWidth || 160}px`};
  }

  .rbc-agenda-date-cell,
  .rbc-agenda-time-cell,
  .rbc-agenda-table th.rbc-header {
    display: none;
  }
  .rbc-agenda-table tr {
    cursor: pointer;
  }
  .rbc-event-content,
  .rbc-agenda-event-cell {
    position: relative;

    .eventContent {
      cursor: pointer;
      width: 100%;
      div.ant-typography {
        margin-bottom: 0;
      }
      .ant-btn-sm {
        font-size: 12px;
        height: auto;
        line-height: 18px;
      }
    }

    h5.eventTitle {
      font-size: 16px;
      margin: 0 !important;
      padding: 0 4px 2px;
      word-break: break-all;
    }

    .eventTime {
      font-size: 12px;
      padding: 2px 4px 0;
      display: flex;
      direction: ltr;
    }
  }
`

// How an appointment reads on the calendar, shared with the popup of a day's other appointments, which is drawn
// outside the calendar
const appointmentStyles = css`
  .tags {
    margin-bottom: 2px;

    .ant-tag {
      margin: 0;
    }
  }

  small .ant-tag {
    font-size: 10px;
    padding: 0 4px;
    line-height: 15px;

    .ant-typography {
      font-size: 10px;
      line-height: 15px;
    }
  }

  .eventContainer {
    text-align: ${props => (props.rtl ? 'right' : 'auto')};
    .event-content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: flex-start;
      max-width: 100%;
    }

    .eventTitle {
      max-width: 100%;
      display: block;

      p,
      .ant-typography {
        margin: 0 1px;
      }

      .patient-name {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        display: inline-flex;
        text-overflow: ellipsis;
        padding: 0 2px;
        &.ar-name {
          justify-content: right;
        }
        &.en-name {
          justify-content: left;
        }
      }
    }

    .appointment-details,
    .patient-id {
      display: none;
    }

    > .ant-space {
      display: flex;
    }

    .ant-tag {
      white-space: break-spaces;
      max-width: 100%;
      max-height: 25px !important;
    }

    &.dark-calendar {
      .eventIcons .ant-space-item {
        background-color: #ffffff;
        padding: 1px;
        border-radius: 20px;
        width: 17px;
        height: 17px;
        display: flex;
        justify-content: center;
        align-items: center;

        .anticon {
          font-size: 15px;
        }
      }
    }
  }

  .agenda-view.eventContainer {
    .eventTitle {
      display: flex !important;
      flex-wrap: wrap;
      align-items: center;

      > .ant-typography {
        margin-right: 5px;
        margin-left: 5px;
      }
    }

    .appointment-details,
    .patient-id {
      display: inline-block;
      margin-bottom: 5px;
    }
  }

  .month-view.eventContainer {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 1px;

    .eventTime,
    .type-tag,
    .tags {
      display: none;
    }

    > .ant-space-horizontal:not(.eventIcons) {
      display: none;
    }

    .hide-on-month {
      display: none;
    }
  }

  .week-view.eventContainer {
    .ant-typography-secondary {
      display: none;
    }
  }

  .eventIcons {
    &.day {
      padding: 2px;
    }
    &.month {
      position: absolute;
      right: ${props => (props.rtl ? 'auto' : '5px')};
      left: ${props => (props.rtl ? '5px' : 'auto')};
      top: 2px;
    }
    .anticon {
      font-size: 13px;
    }
  }
`

export const StyledCalendar = styled(DnDCalendar)`
  background: #ffffff;
  box-shadow: 0 0 6px rgba(0, 21, 41, 0.1);
  //min-height: 90vh;
  padding: 3px;
  border-radius: 3px;

  .rbc-today {
    background: #fafcfd;
  }

  .rbc-month-row {
    min-height: 75px;

    .rbc-event {
      max-width: 100%;
    }

    /* one line for each appointment: the calendar counts how many fit in a day by measuring an empty one, which
       only comes out right when every appointment is the same height, and links to the rest */
    .rbc-row-segment .rbc-event {
      height: 22px;
      overflow: hidden;
    }
  }

  .rbc-addons-dnd-dragged-event {
    opacity: 0 !important;
  }

  .rbc-day-slot .rbc-event-content {
    height: 100%;

    .eventContainer {
      height: 100%;
    }
  }

  ${appointmentStyles}

  .rbc-day-slot .rbc-events-container {
    margin-right: 0;
  }

  .eventTime {
    justify-content: ${props => (props.rtl ? 'flex-end' : 'flex-start')};
  }

  .rbc-day-bg,
  .rbc-date-cell,
  .rbc-events-container,
  .rbc-row:not(.rbc-month-header):not(.rbc-row-resource) {
    cursor: ${props => (props.cursor ? 'default' : 'crosshair')};
  }

  .rbc-timeslot-group {
    min-height: 85px;
  }

  .rbc-time-slot {
    min-height: 40px;
  }

  .rbc-event {
    max-width: 98%;
    padding: 0;
    cursor: ${props => (props.cursor ? 'default' : 'pointer')};

    ::-webkit-scrollbar {
      width: 0;
      height: 0;
      background: transparent;
    }

    &:hover,
    &:focus {
      z-index: 1;
    }
  }

  .rbc-agenda-event-cell {
    position: relative;
  }

  .rbc-event-label {
    color: #434343;
    font-weight: 700;
  }

  //Fix some Styles and colors
  .rbc-time-header {
    height: ${props => (props.defaultView === 'day' ? 20 : 40)}px;
  }

  .rbc-header {
    border-bottom: none;
  }

  .rbc-addons-dnd-resize-ns-anchor {
    z-index: 1;
  }

  .ant-typography-ellipsis strong > span {
    font-weight: 600;
  }

  //Fix scrolling
  .rbc-time-content {
    border-top: none;
    //overflow-y: hidden;
    //align-items: stretch;
  }

  .rbc-time-slot .rbc-label {
    font-size: 12px;
    padding: 0 8px;
    color: #888888;
    font-weight: 700;
    display: inline-block;
    direction: ltr;
  }

  .rbc-day-slot .rbc-time-slot {
    border-top: 1px solid #f1f1f1;
  }

  .rbc-events-container,
  .rbc-time-gutter.rbc-time-column,
  .rbc-time-view-resources,
  .rbc-time-header-content,
  .rbc-time-header-gutter {
    border-color: #eeeeee !important;
  }

  span.rbc-toolbar-label {
    font-weight: 700;
    color: var(--main-gradient);
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .ant-picker {
      width: 40px;
      margin: 0 0.7rem;
      border-radius: 4px;
      padding: 0;

      .ant-picker-input {
        padding: 4px 12px;
      }

      input {
        opacity: 0;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        left: 0;
      }

      .ant-picker-suffix {
        margin: 0;
      }

      &:hover .ant-picker-suffix {
        color: var(--ant-primary-color-hover);
      }
    }
  }

  .select-rooms {
    min-width: 100px;
  }

  .rbc-toolbar > .ant-space {
    flex-grow: 1;
    justify-content: flex-end;
  }

  .rbc-toolbar .ant-switch {
    padding: 0;
    color: rgba(0, 0, 0, 0.88);
    font-size: 14px;
    border-radius: 100px;
    border: 0;
    background: rgba(0, 0, 0, 0.25);
    line-height: 22px;

    &.ant-switch-checked {
      background: #0077b9;

      &:hover {
        background: rgba(0, 119, 185, 0.84);
      }
    }

    &:hover {
      background: rgba(0, 0, 0, 0.45);
    }
  }

  .rbc-toolbar button:not(.ant-switch),
  .rbc-btn-group button:not(.ant-switch) {
    line-height: 1.499;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;
    border: 1px solid #d9d9d9 !important;
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    user-select: none;
    touch-action: manipulation;
    height: 32px;
    font-size: 14px;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.65);
    outline: none !important;
    background: #ffffff !important;
    padding: 0;

    span {
      display: flex;
      padding: 0 15px;

      svg {
        width: 14px;
        height: 14px;
      }
    }

    .ant-typography {
      display: inline-block;
      padding: 0 15px;
      color: inherit;
    }

    &:hover,
    &:focus,
    &.rbc-active {
      background: #ffffff !important;
      color: var(--ant-primary-color) !important;
      box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.125);
    }

    &.rbc-active {
      box-shadow: inset 0 1px 4px rgba(0, 60, 107, 0.13);
    }
  }

  @media screen and (max-width: 1500px) {
    .rbc-toolbar .rbc-toolbar-label {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 900px) {
    padding: 0;
    .rbc-toolbar {
      .ant-space {
        justify-content: center;
      }
      .rbc-toolbar-label {
        order: 2;
        font-size: 12px;
      }

      > span {
        margin: 5px;
      }
    }
    .rbc-toolbar button:not(.ant-switch) span,
    .rbc-btn-group button:not(.ant-switch) span {
      padding: 0 8px;
    }
  }
`

export const StyledWhatsappButton = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-btn:not(.ant-btn-rtl) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .ant-btn-rtl {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .ant-select .ant-select-selector {
    background: var(--main-color);
    color: #fff;
    border: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    min-width: 90px;
  }

  &.default {
    .ant-select .ant-select-selector {
      background: #fff;
      color: rgba(0, 0, 0, 0.88);
      border: 1px solid #d9d9d9;
    }

    .ant-select .ant-select-selector,
    .ant-select-arrow,
    .ant-typography {
      color: rgba(0, 0, 0, 0.88);
    }

    .ant-select-selection-placeholder {
      color: rgba(0, 0, 0, 0.6);
    }
  }

  .ant-select:not(.ant-select-rtl) .ant-select-selector {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .ant-select-rtl .ant-select-selector {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .ant-select-arrow,
  .ant-typography {
    color: #fff;
  }

  .ant-select-suffix {
    margin: 0;
  }

  .ant-form-item-feedback-icon {
    display: none;
  }

  .ant-select-selection-placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
`

export const StyledFooter = styled.div`
  background: #ffffff;
  padding: 10px;
  margin: 10px 0;
  box-shadow: 0 0 6px rgba(0, 21, 41, 0.1);
  border-radius: 3px;
  > div:not(.ant-space) {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row wrap;
    .ant-typography {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
    .ant-tag {
      height: 0;
      width: 0;
      padding: 6px;
      border-radius: 24px;
      border-width: 4px;
    }
    .anticon,
    .ant-tag {
      margin: 0 4px;
    }
  }
`

// The popup listing the rest of a month day's appointments, one line each as they are in the day itself
export const StyledCalendarOverlay = createGlobalStyle`
  .rbc-overlay {
    ${appointmentStyles}

    .rbc-event {
      height: 22px;
      overflow: hidden;
    }

    .rbc-event-content {
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .eventContent {
        cursor: pointer;
        width: 100%;
      }
    }
  }
`
